import { render, staticRenderFns } from "./purshase-product-info.vue?vue&type=template&id=69b3a06b"
import script from "./purshase-product-info.vue?vue&type=script&lang=js"
export * from "./purshase-product-info.vue?vue&type=script&lang=js"
import style0 from "./purshase-product-info.vue?vue&type=style&index=0&id=69b3a06b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports